// Libraries
import { api } from "@service/api";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Components & Hooks
import { config } from "config";
import { Button } from "@components/buttons/button";
import { Input } from "@components/forms/input";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import Loading from "@components/loading";
import { TrackingDetails } from "@components/tracking";
import { TrackingNotFound } from "@components/tracking/not-found";

// Images
import logo from "@assets/img/logo/logo-02.png";
import { ITrackingDTO } from "@hooks/dtos/ITrackingDTO";
import { ITrackingHistDTO } from "@hooks/dtos/ITrackingHistDTO";

// Icons

export function Tracking() {
  const navigate = useNavigate();
  const { code } = useParams<string>();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  // --- Tracking Info --- //
  const [tracking, setTracking] = useState<ITrackingDTO>();
  const [trackingHist, setTrackingHist] = useState<ITrackingHistDTO[]>();

  // --- If Not Found the Tracking Code --- //
  const [errorTrackingCode, setErrorTrackingCode] = useState<string>("");

  async function getInfoByTrackingCode(code: string) {
    try {
      const params = `?codeId=${code}`;
      const response = await api.get(`/misc/tracking/code/${params}`);
      const tracking = response.data;

      // --- If don't found the code --- //
      if (!tracking) {
        pushToastify({
          message: "Houve um erro ao localizar este código, tente novamente.",
          type: "info",
          theme: "dark",
          pauseOnHover: true,
        });

        // --- Redirect the User --- //
        setTimeout(() => {
          navigate(`/`);
        }, 2000);

        return;
      }

      // --- Set the Tracking --- //
      setTracking(tracking);
      console.log({ tracking });
    } catch (err: any) {
      pushToastify({
        message: err?.response?.data.message ?? "Ocorreu um erro!",
        type: "error",
        theme: "dark",
      });
    }
  }

  async function getHistByTrackingId(id: number) {
    try {
      const params = `?id=${id}`;
      const response = await api.get(`/misc/trackingHist/trackingId/${params}`);
      const trackingHists: ITrackingHistDTO[] = response.data;
      // console.log({ trackingHists });

      setTrackingHist(trackingHists);

      setIsLoading(false);
    } catch (err: any) {
      pushToastify({
        message: err?.response?.data.message ?? "Ocorreu um erro!",
        type: "error",
        theme: "dark",
      });
    }
  }

  useEffect(() => {
    if (code) {
      getInfoByTrackingCode(code);
    } else {
      pushToastify({
        message: "Ocorreu um erro ao identificar o seu pedido!",
        type: "error",
        theme: "dark",
      });
    }
  }, []);

  useEffect(() => {
    if (tracking) {
      getHistByTrackingId(tracking.id);
    }
  }, [tracking]);

  return (
    <>
      {/* Content */}
      <div
        className="container-fluid d-flex flex-column flex-sm-row justify-content-start align-items-start gap-2 gap-sm-3"
        style={{
          paddingBottom: "2.5rem",
          paddingTop: "clamp(2rem, 5vw, 5rem)",
          paddingLeft: "clamp(1rem, 10vw, 20rem)",
          paddingRight: "clamp(1rem, 10vw, 20rem)",
        }}
      >
        <div className="col-md-12">
          {isLoading ? (
            <>
              <div className="d-flex flex-column justify-content-center align-items-center py-2">
                <Loading
                  type="stable"
                  size="lg"
                  color="#ccc"
                  style={{
                    width: "80px",
                    height: "80px",
                    marginBottom: "1rem",
                  }}
                />
                <span className="fs-4 text-muted">Carregando...</span>
              </div>
            </>
          ) : (
            <>
              {errorTrackingCode ? (
                <>
                  <TrackingNotFound trackingCode={errorTrackingCode} />
                </>
              ) : (
                <>
                  <TrackingDetails
                    tracking={tracking as ITrackingDTO}
                    trackingHist={trackingHist as ITrackingHistDTO[]}
                  />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
